import moment from 'moment';
import * as React from 'react';
import { DateTimePicker } from 'react-widgets';
import { FilterProps } from 'src/components/react-table/filters/types';
import { useCookies } from 'react-cookie';

moment.locale('en');

function dateSeanceDateFilterMulti<T extends Record<string, unknown>>(): React.FunctionComponent<FilterProps<T>> {
    return React.memo(({ column: { setFilter, id } }: FilterProps<T>) => {
        const [date, setDate] = React.useState<any>({});

        const [cookiesDateFrom, setCookieDateFrom] = useCookies(['fromDate']);
        const [cookiesDateTo, setCookieDateTo] = useCookies(['toDate']);

        const handleChange1 = (value: Date | undefined) => {
            if (value) {
                if (Object.values(date).length) {
                    setDate({ ...date, [`${id}[after]`]: moment(value).format('YYYY-MM-DD') });
                    setFilter({ ...date, [`${id}[after]`]: moment(value).format('YYYY-MM-DD') });
                    setCookieDateFrom('fromDate', value ? value : undefined, {
                        path: '/',
                    });
                } else {
                    setDate({ ...date, [`${id}[after]`]: moment(value).format('YYYY-MM-DD') });
                    setCookieDateFrom('fromDate', value ? value : undefined, {
                        path: '/',
                    });
                }
            }
        };
        const handleChange2 = (value: Date | undefined) => {
            if (value) {
                if (Object.values(date).length) {
                    setDate({ ...date, [`${id}[before]`]: moment(value).format('YYYY-MM-DD') });
                    setFilter({ ...date, [`${id}[before]`]: moment(value).format('YYYY-MM-DD') });
                    setCookieDateTo('toDate', value ? value : undefined, {
                        path: '/',
                    });
                } else {
                    setDate({ ...date, [`${id}[before]`]: moment(value).format('YYYY-MM-DD') });
                    setCookieDateTo('toDate', value ? value : undefined, {
                        path: '/',
                    });
                }
            }
        };

        return (
            <div className={'d-flex'} style={{ minWidth: 230 }}>
                <DateTimePicker format="MM-DD-YYYY" time={false} onChange={handleChange1} />
                <DateTimePicker format="MM-DD-YYYY" time={false} onChange={handleChange2} />
            </div>
        );
    });
}

export default dateSeanceDateFilterMulti;
